// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSToastCloseButton_button--default___CEvn"};